import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class ActivityService {
  static ENDPOINT = `${BASE}/activity`;

  static async getAll() {
    return await request({
      url: `${this.ENDPOINT}/`,
      headers: {'Accept': 'application/json'}
    })
  }

  static async get(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      headers: {'Accept': 'application/json'}
    })
  }
}

export default ActivityService;
